import { Children, PropsWithChildren } from 'react';
import { createUseStyles } from 'react-jss';
import cn from 'classnames';

type LoaderIndicatorProps = {
  small?: boolean,
};

const LoaderIndicator = (props: PropsWithChildren<LoaderIndicatorProps>) => {
  const {
    children,
    small = false,
  } = props;
  const classes = useStyles();

  return (
    <div className={cn(classes.indicator, { small })}>
      <div />
      {Children.count(children) > 0 && <div className={classes.child}>{children}</div>}
    </div>
  );
};

const useStyles = createUseStyles({
  indicator: {
    '&': {
      position: 'relative',
      width: '7rem',
      height: '7rem',
      transform: 'translateZ(0)',
    },
    '&.small': {
      width: '3rem',
      height: '3rem',
    },
    '& > div:first-child': {
      position: 'absolute',
      borderRadius: '50%',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      border: '.6rem solid #fff',
      borderLeftColor: '#26bda5',
      animation: '$coverLoader 1.1s linear infinite',
    },
  },
  child: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  '@keyframes coverLoader': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
});

export default LoaderIndicator;
